import { Body } from '@moniebook-web/components/atoms/typography';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { useEffect } from 'react';

interface Props {
    syncPercentage: number;
}

export function FullSyncProgressIndicator({ syncPercentage }: Readonly<Props>) {
    const motionValue = useMotionValue(0);
    const rounded = useTransform(motionValue, (latest) => Math.round(latest));

    useEffect(() => {
        const animation = animate(motionValue, syncPercentage, {
            duration: 0.5,
            ease: 'easeOut',
        });

        return animation.stop;
    }, [syncPercentage, motionValue]);

    return (
        <div className='my-10vh flex flex-col items-center justify-center gap-24'>
            <div className='h-4 w-295 overflow-hidden rounded-8 bg-feedback-default-ghost-default'>
                <div
                    aria-label='Sync process indicator'
                    style={{ width: `${syncPercentage}%` }}
                    className='h-full bg-action-default-filled-default transition-all duration-300 ease-in-out'
                />
            </div>

            <Body className='text-content-subtext-alternative'>
                <motion.span>{rounded}</motion.span>%
            </Body>
        </div>
    );
}
